import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getManageAreaList_action, updateManageArea_action } from "../../../../../actions/admin_module_action/master_action/manage_area_action";


class ManageArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            chapterList: [],
            totalExhibitionArea: '',
            StallSizeList: [],
            firstInstallment: '',
            secondInstallment: '',
        }
        // this.chapterRecord = this.chapterRecord.bind(this)
        this.onChangeTotalSpace = this.onChangeTotalSpace.bind(this)
        this.onAddRow = this.onAddRow.bind(this)
        this.onChangeBuffer = this.onChangeBuffer.bind(this)
        this.getManageAreaList = this.getManageAreaList.bind(this)

    }

    componentDidMount() {
        this.getManageAreaList()
        setTimeout(() => {
            console.log(this.state.chapterList, this.state.StallSizeList)
        }, 200);
    }

    onAddRow(e) {
        e.preventDefault();
        // console.log(this.state.listLength)
        const { StallSizeList } = this.state
        var id = StallSizeList.length + 1
        var map = {
            stallSize: '',
            // is_delete: false,
            PriceINR: "",
            PriceUSD: "",

        }
        StallSizeList.push(map)
        this.setState({ StallSizeList: StallSizeList, })
        console.log(this.state.StallSizeList)
    }

    onChangeTotalSpace(e, id) {
        e.preventDefault()
        const { totalExhibitionArea, chapterList } = this.state
        console.log(id, e.target.value, totalExhibitionArea)
        if (totalExhibitionArea == '' || totalExhibitionArea == null) {
            toastError("please fill total exhibition area")
        }
        else {
            // var list = [...chapterList]
            chapterList.map((data, i) => {
                if (id == i) {
                    data.TotalArea = parseInt(e.target.value)
                }
            })
        }
        var total = 0
        for (var i = 0; i < chapterList.length; i++) {
            total = chapterList[i].TotalArea + total
        }
        if (total > parseInt(totalExhibitionArea)) {
            // var list = [...chapterList]
            chapterList.map((data, i) => {
                if (id == i) {
                    data.TotalArea = ''
                    setTimeout(() => {
                        // this.setState({ chapterList: chapterList })
                        toastError("total areas should not be more than total exhibiton area")
                    }, 200);
                }
            })
        }
        setTimeout(() => {
            this.setState({ chapterList: chapterList })
        }, 200);
    }

    onChangeBuffer(e, id) {
        e.preventDefault()
        const { totalExhibitionArea, chapterList } = this.state
        console.log(id, e, totalExhibitionArea)
        if (totalExhibitionArea == '' || totalExhibitionArea == null) {
            toastError("please fill total exhibition area")
        }
        else {
            // var list = [...chapterList]
            chapterList.map((data, i) => {
                if (id == i) {
                    if (data.TotalArea == '' || data.TotalArea == null) {
                        toastError("please fill total area")
                    }
                    else {
                        if (parseInt(data.TotalArea - parseInt(e.target.value)) < 0) {
                            data.Buffer = ''
                            data.Available = ''
                            toastError("Buffer cannot be greater than total area")
                        }
                        else {
                            data.Buffer = parseInt(e.target.value)
                            data.Available = parseInt(data.TotalArea - parseInt(e.target.value))
                        }

                        console.log(data.TotalArea, data.Buffer, e.target.value)
                    }
                }
            })
        }
        setTimeout(() => {
            this.setState({ chapterList: chapterList })
            console.log(chapterList)
        }, 200);
    }

    getManageAreaList() {
        this.setState({ isLoading: true })
        this.props.getManageAreaList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({
                        totalExhibitionArea: data.data.TotalExhibitionArea,
                        firstInstallment: data.data.firstInstallment, secondInstallment: data.data.secondinstallment, chapterList: data.data.chapterList, StallSizeList: data.data.stallSizeList
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    updateManageArea() {
        const { totalExhibitionArea, firstInstallment, secondInstallment, chapterList, StallSizeList } = this.state
        this.setState({ isLoading: true })
        var tempchapterList = chapterList
        tempchapterList.map((element) => (
            delete element['Available'],
            element.ExhibitionID = JSON.parse(sessionStorage.getItem("sessionExhibitionID"))))
        this.props.updateManageArea_action(totalExhibitionArea, firstInstallment, secondInstallment, tempchapterList)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { isLoading, chapterList, firstInstallment, secondInstallment, StallSizeList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-container p-2 mt-5">
                    <div className="row ">
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                            <div className="row ">
                                {/* <div class="card-body mt-5"> */}
                                <div class="col-md-4">
                                    <label for="validationCustom03">Total Exhibition Area<span style={{ color: 'red' }}>*</span></label>
                                    <input onChange={(e) => this.setState({ totalExhibitionArea: e.target.value })} type="number" class="form-control" placeholder="" />
                                </div>
                                {/* </div> */}
                                <div class="table-responsive">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-3">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Primary Chapter<span style={{ color: 'red' }}>*</span></th>
                                                <th className="text-center">Total Space<span style={{ color: 'red' }}>*</span></th>
                                                <th className="text-center">Buffer<span style={{ color: 'red' }}>*</span></th>
                                                <th className="text-center">Available</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                chapterList.length > 0 ? <>{
                                                    chapterList.map((data, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center">{data.ChapterName}</td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value={data.TotalSpace}
                                                                    onChange={(e) => this.onChangeTotalSpace(e, i)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value={data.Buffer}
                                                                    onChange={(e) => this.onChangeBuffer(e, i)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value={data.Available}
                                                                    disabled={true}
                                                                // onChange={(e) => this.onEnterProductName(e, ID)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div class="card-body pt-2">
                                    <button type="button" class="btn btn-primary rounded-0" style={{ float: 'right' }} onClick={(e) => this.onAddRow(e)}>
                                        Add Row
                                    </button>
                                    <div class="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-3">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Stall Size<span style={{ color: 'red' }}>*</span></th>
                                                    <th className="text-center">Price (INR)<span style={{ color: 'red' }}>*</span></th>
                                                    <th className="text-center">Price (USD)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    StallSizeList.length > 0 ? <>{
                                                        StallSizeList.map((data, i) => (
                                                            <tr key={Math.random()}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={data.ExhibitionStallDimension}
                                                                    // onChange={(e) => this.onChangeTotalSpace(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={data.Price_INR}
                                                                    // onChange={(e) => this.onEnterProductName(e, ID)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={data.Price_USD}
                                                                    // disabled={true}
                                                                    // onChange={(e) => this.onEnterProductName(e, ID)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </> :
                                                        <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row mt-3">
                                        {/* <div class="card-body mt-5"> */}
                                        <div class="col-md-4">
                                            <label for="validationCustom03">Ist Installment %</label>
                                            <input onChange={(e) => this.setState({ firstInstallment: e.target.value })} type="number" class="form-control" placeholder="" />
                                        </div>
                                        <div class="col-md-4">
                                            <label for="validationCustom03">2nd Installment %</label>
                                            <input onChange={(e) => this.setState({ secondInstallment: e.target.value })} type="number" class="form-control" placeholder="" />
                                        </div>
                                        <div class="col-md-4">
                                            <button type="button" class="btn btn-primary rounded-0 mt-4" style={{ float: 'right' }}>
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getManageAreaList_action, updateManageArea_action })(ManageArea));